import React from 'react';
import styled from '@emotion/styled';
import { Idea, StartProject, CreateProject } from './';
import { Colors, Container, device, Section } from 'utils';

const HowToStartProjectWrapper = styled.section`
  text-align: center;
`;
const SectionTitle = styled.div`
  h3 {
    display: inline-block;
    position: relative;
    font-size: 65px;
    font-weight: 600;
    margin-bottom: 10px;
    margin-top: 0;
    line-height: 1;
    color: ${(props) => (props.color ? `${props.color}` : Colors.white)};
    @media ${device.allMobile} {
      font-size: 30px;
    }
    @media ${device.laptop} {
      font-size: 30px;
    }
  }
`;
export default function HowToStartProject() {
  return (
    <Section>
      <HowToStartProjectWrapper>
        <Container>
          <>
            <SectionTitle color={Colors.GreenColor}>
              <h3> Wie startest du ein Projekt?</h3>
            </SectionTitle>
            <Idea />
          </>
        </Container>
        <StartProject />
        <Container>
          <>
            <CreateProject />
          </>
        </Container>
      </HowToStartProjectWrapper>
    </Section>
  );
}
